import React from "react";

import { css } from "@emotion/react";

import gasIcon from "../../../../../../../images/oeko_gas.jpg";
import {
    formattedToNumber,
    roundNumber,
} from "../../../../../../../utils/NumberHelpers";
import Campaign from "../../../../../../shared/Campaign";
import Margin from "../../../../../../shared/Margin";
import TextAlign from "../../../../../../shared/TextAlign";
import * as styles from "./style.module.scss";

const boldStyles = css`
    font-weight: 500;
`;

const GasProduct = ({ consumption, product }) => {
    return (
        <React.Fragment>
            <div className="box product-details">
                <div className="columns is-mobile">
                    <div className="column ">Bedarf:</div>
                    <div className="column details-value">
                        {consumption}&nbsp;kWh
                    </div>
                </div>

                <div className="columns is-mobile">
                    <div className="column ">Arbeitspreis:</div>
                    <div className="column details-value">
                        {product.arbeitspreisCtKWhBrutto} ct/kWh
                    </div>
                </div>

                <div className="columns is-mobile">
                    <div className="column">Grundpreis (brutto):</div>
                    <div className="column details-value">
                        {product.grundpreisBrutto}&nbsp;&euro;/Jahr
                    </div>
                </div>
                <div className="columns is-mobile">
                    <div className="column">Abschlag Monatlich:</div>
                    <div className="column details-value">
                        {product.Monatlich}&nbsp;&euro; inkl. MwSt.
                    </div>
                </div>

                <Campaign name="mitmachen2020">
                    <Campaign.Content>
                        <div
                            className={`columns is-mobile ${styles.totalAmount}`}
                        >
                            <div className="column">Gesamt:</div>
                            <div
                                className={`column ${styles.totalAmountValue} ${styles.lineThrough}`}
                            >
                                <span className={styles.blackText}>
                                    {product.gesamtpreisOhneBoniBrutto}€
                                </span>
                            </div>
                        </div>
                        <div
                            className={`columns is-mobile ${styles.reduction}`}
                        >
                            <div className="column ">Abzüglich:</div>
                            <div className={`column ${styles.reductionValue}`}>
                                -100,00€
                            </div>
                        </div>
                        <div
                            className={`columns is-mobile ${styles.totalAmount}`}
                        >
                            <div className="column ">Gesamt:</div>
                            <div
                                className={`column ${styles.totalAmountValue}`}
                            >
                                {roundNumber(
                                    formattedToNumber(
                                        product.gesamtpreisOhneBoniBrutto
                                    ) - 100
                                )}
                                €
                            </div>
                        </div>
                    </Campaign.Content>
                    <Campaign.Fallback>
                        <div className="columns is-mobile total-amount">
                            <div className="column ">Gesamt:</div>
                            <div className="column">
                                {product.gesamtpreisOhneBoniBrutto}€
                            </div>
                        </div>
                    </Campaign.Fallback>
                </Campaign>
                <ul>
                    <li>
                        <Margin top="20">
                            <Margin right="10" Component="span">
                                Kündigungsfrist:
                            </Margin>
                            <span css={boldStyles}>
                                {product.kuendigungsfrist}
                            </span>
                        </Margin>
                    </li>
                    <li>
                        <Margin top="20">
                            <Margin right="10" Component="span">
                                Mindestvertragslaufzeit:
                            </Margin>
                            <span css={boldStyles}>
                                {product.vertragsverlaengerung}
                            </span>
                        </Margin>
                    </li>
                    <li>
                        <Margin top="20">
                            <Margin right="10" Component="span">
                                eingeschränkte Preisgarantie für 12 Monate
                            </Margin>
                            <span css={boldStyles}>
                                ({product.preisgarantieBestandteile})
                            </span>
                        </Margin>
                    </li>
                    <li>
                        <Margin top="20">
                            <Margin right="10" Component="span">
                                Alle angezeigten Preise sind Bruttopreise und
                                beinhalten alle Steuern und Abgaben.
                            </Margin>
                        </Margin>
                    </li>
                    <li>
                        <Margin top="20">
                            <Margin right="10" Component="span">
                                Stand:{" "}
                                {product.gueltigVon
                                    .split("-")
                                    .reverse()
                                    .join(".")}
                            </Margin>
                        </Margin>
                    </li>
                </ul>

                {product.isOekogasTarif && (
                    <div>
                        <TextAlign align="center">
                            <img style={{ width: "30%" }} src={gasIcon} />
                        </TextAlign>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
};

export default GasProduct;
